import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import styles from './style.module.scss'
import { Helmet } from 'react-helmet'
import { HeaderImg } from '../../Components/Header'
import headerImg from '../../Assets/headerImgs/abd.jpg'

import servicesImg1 from '../../Assets/services-market/super-market-srilanka.jpg'
import servicesImg2 from '../../Assets/services-market/freight-forwarding-companies1.jpg'
import servicesImg3 from '../../Assets/services-market/outdoor20catering20in20star20class20hotels1.jpg'
import servicesImg4 from '../../Assets/services-market/Private-parties1.jpg'
import servicesImg5 from '../../Assets/services-market/government20supplier1.png'
import servicesImg6 from '../../Assets/services-market/International-events.jpg'

import servicesCategoriesImg1 from '../../Assets/services-market/1.Restaurant-Supply.jpg'
import servicesCategoriesImg2 from '../../Assets/services-market/2.Bakery.jpg'
import servicesCategoriesImg3 from '../../Assets/services-market/3.beverages.jpg'
import servicesCategoriesImg4 from '../../Assets/services-market/4.Confectionery.jpg'
import servicesCategoriesImg5 from '../../Assets/services-market/5.Construction-ice-cubes.jpg'
import servicesCategoriesImg6 from '../../Assets/services-market/6.Dairy-products.jpg'
import servicesCategoriesImg7 from '../../Assets/services-market/7.Pharmaceutical.jpg'
import servicesCategoriesImg8 from '../../Assets/services-market/8.Fruit-and-vegetables.jpg'
import servicesCategoriesImg9 from '../../Assets/services-market/9.meat_.jpg'
import servicesCategoriesImg10 from '../../Assets/services-market/10.poultry.jpg'
import servicesCategoriesImg11 from '../../Assets/services-market/11.sea-food.jpg'
import Copyrights from '../../Components/Copyrights'
import Aos from 'aos'
import 'aos/dist/aos.css';

const ServicesMarketPage = () => {

  useEffect(() => {
    Aos.init({
      duration: 1000
    })
  }, [])

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Services Market</title>
      </Helmet>
      <Navbar active="services-market" />
      {/* ServicesMarketPage */}
      <HeaderImg img={headerImg} alt="headerImg" />
      <div className={styles.servicesMarketCont}>
        <p>Wedage & Company initiated its solutions during the late 1990s to fill an important gap within the supply chain market of refrigerated transport in Sri Lanka. Since the climax of the war, Sri Lanka has seen a steady growth in the food services and the hotel industry. This has provided us an important platform to expand our business further.</p>
        <br />
        <p>Wedage & Company doesn't just deliver a service. We provide added value to the goods of our customers by introducing SLSI quality standards and provide insurance to the goods in our care with the touch of precision and reliability like no other company in Sri Lanka.</p>
        <br />
        <p>Our unique and powerful supply chain solutions have created a string of customers that are loyal to our brand because they know that we provide the best solutions to their refrigerated transportation needs at the best price, but most importantly the assurance of quality unmatched in the industry.</p>
        <div className={styles.imageCardsCont}>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesImg1} alt="imageCard"/>
            <p>Provide transport to food outlets and restaurants island wide</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesImg2} alt="imageCard"/>
            <p>Provide service to freight Provide service to freight forwarding companies</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesImg3} alt="imageCard"/>
            <p>Transport service for outdoor catering into 5 star hotels in Colombo</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesImg4} alt="imageCard"/>
            <p>Private parties Private parties ( we provide out vehicles )</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesImg5} alt="imageCard"/>
            <p>Government suppliers</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesImg6} alt="imageCard"/>
            <p>Transportation food items for International events</p>
          </div>
        </div>
        <p>Some of the products we deal with are as follows but if your product not included here, just talk to us. We have solutions for any product which need to be transported under refrigeration other than harmful chemicals and weapons</p>
        <div className={styles.imageCardsCont}>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg1} alt="imageCard"/>
            <p>Restaurants and Catering</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg2} alt="imageCard"/>
            <p>Bakery</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg3} alt="imageCard"/>
            <p>Beverages</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg4} alt="imageCard"/>
            <p>Confectionary</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg5} alt="imageCard"/>
            <p>Construction ( for transportation of ice cubes )</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg6} alt="imageCard"/>
            <p>Dairy</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg7} alt="imageCard"/>
            <p>Pharmaceutical</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg8} alt="imageCard"/>
            <p>Fruit & Vegetable</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg9} alt="imageCard"/>
            <p>Meat Products</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg10} alt="imageCard"/>
            <p>Poultry</p>
          </div>
          <div className={styles.imageCard} data-aos="fade-up">
            <img src={servicesCategoriesImg11} alt="imageCard"/>
            <p>Seafood</p>
          </div>
        </div>
      </div>
      <Copyrights />
    </div>
  )
}

export default ServicesMarketPage